import { types, actions } from './requests'
export const DELETEMASTER_TYPES = {
    ...types('DELETEMASTER'),
}
export const DELETEMASTER_ACTIONS = {
    ...actions('DELETEMASTER'),
}